module.exports = new __parcel__URL__("pase-pro.7692fa5c.webp").toString();